<template>

<div>
<Home />
<b-sidebar
v-if="!isLoggedIn"
      type="is-light"
      class="welcome-pop"
      :fullheight="true"
      :fullwidth="true"
      :overlay="true"
      :right="true"
      :can-cancel="false"
      :open.sync="open"
    >
      <div class="columns is-vcentered is-centered full-height">
            <div class="column">
                <SignUp 
                :open.sync="open"
                @update="open = $event;"
                 />
            </div>
        </div>
    </b-sidebar>



    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Home from '../components/Home.vue';
import SignUp from '../components/SignUp.vue';
export default {
    data() {
        return {
            open: false,
        };
    },
    computed: {     
        ...mapState('auth', ['user', 'isLoggedIn']),
    }, 
    // mounted() {
    //     if(!this.isLoggedIn) {
    //         setTimeout(function () { 
    //             this.openWelcome() 
    //             }.bind(this), 4000)
    //     }
    // },
    components: {
        Home,
        SignUp
    },
    methods: {
        openWelcome() {
            this.open = true;
        },
        ...mapActions('auth', ['login', 'logout']), 
  }
};

</script>
